export const ourProducts = [
    {
      title: 'Marine Research Data Analysis and Visualization Software',
      subtitle:
        'Dive into the depths of marine research with our software. Analyze and visualize oceanographic data to unlock insights crucial for scientific discoveries and environmental conservation.',
      img: 'url(/industries/ocean-technology/marine-research-data-analysis-and-visualization-software.jpg)', 
      content:
        'Analyze and visualize oceanographic data to unlock insights crucial for scientific discoveries and environmental conservation with our Marine Research Data Analysis and Visualization Software.',
      link: '/industries/ocean-technology/products/marine-research-data-analysis-and-visualization-software',
    },
    {
      title: 'Underwater Robotics Control and Data Acquisition Systems',
      subtitle:
        'Explore the underwater world with precision using our Robotics Control Systems. Seamlessly operate underwater vehicles, collect data, and conduct research with cutting-edge control and data acquisition technology.',
      img: 'url(/industries/ocean-technology/underwater-robotics-control-and-data-acquisition-systems.jpg)',
      content:
        'Seamlessly operate underwater vehicles, collect data, and conduct research with cutting-edge control and data acquisition technology with our Underwater Robotics Control and Data Acquisition Systems.',
      link: '/industries/ocean-technology/products/underwater-robotics-control-and-data-acquisition-systems',
    },
    {
      title: 'Oceanographic Data Management and Mapping Software',
      subtitle:
        'Navigate the vast ocean of data with our Oceanographic Data Management Software. Efficiently manage and map oceanographic data for comprehensive insights into ocean conditions and phenomena.',
      img: 'url(/industries/ocean-technology/oceanographic-data-management-and-mapping-software.jpg)',
      content:
        'Efficiently manage and map oceanographic data for comprehensive insights into ocean conditions and phenomena with our Oceanographic Data Management and Mapping Software.',
      link: '/industries/ocean-technology/products/oceanographic-data-management-and-mapping-software',
    },
    {
      title: 'Autonomous Underwater Vehicle (AUV) Fleet Management Systems',
      subtitle:
        'Optimize the deployment and operation of your AUV fleet with our management systems. Ensure efficient data collection and exploration in diverse underwater environments.',
      img: 'url(/industries/ocean-technology/auv-fleet-management-systems.jpg)',
      content:
        'Ensure efficient data collection and exploration in diverse underwater environments with our Autonomous Underwater Vehicle (AUV) Fleet Management Systems.',
      link: '/industries/ocean-technology/products/auv-fleet-management-systems',
    },
    {
      title: 'Offshore Operations Monitoring and Optimization Platforms',
      subtitle:
        'Enhance efficiency and safety in offshore operations with our monitoring and optimization platforms. Real-time insights empower decision-makers to optimize processes and ensure operational excellence.',
      img: 'url(/industries/ocean-technology/offshore-operations-monitoring-and-optimization-platforms.jpg)',
      content:
        'Real-time insights empower decision-makers to optimize processes and ensure operational excellence in offshore operations with our Offshore Operations Monitoring and Optimization Platforms.',
      link: '/industries/ocean-technology/products/offshore-operations-monitoring-and-optimization-platforms',
    },
    {
      title: 'Coastal and Marine Environmental Monitoring Software',
      subtitle:
        'Safeguard coastal and marine environments with our monitoring software. Track environmental changes, identify potential threats, and contribute to the conservation of marine ecosystems.',
      img: 'url(/industries/ocean-technology/coastal-and-marine-environmental-monitoring-software.jpg)',
      content:
        'Track environmental changes, identify potential threats, and contribute to the conservation of marine ecosystems with our Coastal and Marine Environmental Monitoring Software.',
      link: '/industries/ocean-technology/products/coastal-and-marine-environmental-monitoring-software',
    },
    {
      title: 'Fisheries Management and Tracking Systems',
      subtitle:
        'Support sustainable fisheries with our management and tracking systems. Monitor fish populations, track fishing activities, and contribute to responsible fisheries management practices.',
      img: 'url(/industries/ocean-technology/fisheries-management-and-tracking-systems.jpg)',
      content:
        'Monitor fish populations, track fishing activities, and contribute to responsible fisheries management practices with our Fisheries Management and Tracking Systems.',
      link: '/industries/ocean-technology/products/fisheries-management-and-tracking-systems',
    },
    {
      title: 'Real-time Tide and Current Prediction Software',
      subtitle:
        'Navigate coastal waters with confidence using our Tide and Current Prediction Software. Gain real-time insights into tide and current patterns for safer and more efficient marine operations.',
      img: 'url(/industries/ocean-technology/real-time-tide-and-current-prediction-software.jpg)',
      content:
        'Gain real-time insights into tide and current patterns for safer and more efficient marine operations with our Real-time Tide and Current Prediction Software.',
      link: '/industries/ocean-technology/products/real-time-tide-and-current-prediction-software',
    },
    {
      title: 'Ocean Exploration and Seafloor Mapping Tools',
      subtitle:
        'Embark on explorations with our tools for ocean exploration and seafloor mapping. Uncover the mysteries of the ocean depths and create detailed maps for scientific research and resource management.',
      img: 'url(/industries/ocean-technology/ocean-exploration-and-seafloor-mapping-tools.jpg)',
      content:
        'Uncover the mysteries of the ocean depths and create detailed maps for scientific research and resource management with our Ocean Exploration and Seafloor Mapping Tools.',
      link: '/industries/ocean-technology/products/ocean-exploration-and-seafloor-mapping-tools',
    },
    {
      title: 'Ocean Energy Resource Assessment Software',
      subtitle:
        'Harness the power of the ocean with our Energy Resource Assessment Software. Evaluate and optimize the potential for ocean energy resources, contributing to sustainable and renewable energy solutions.',
      img: 'url(/industries/ocean-technology/ocean-energy-resource-assessment-software.jpg)',
      content:
        'Evaluate and optimize the potential for ocean energy resources, contributing to sustainable and renewable energy solutions with our Ocean Energy Resource Assessment Software.',
      link: '/industries/ocean-technology/products/ocean-energy-resource-assessment-software',
    },
    {
      title: 'Submarine Cable Route Planning and Maintenance Systems',
      subtitle:
        'Ensure the reliability of submarine cable networks with our planning and maintenance systems. Optimize route planning, monitor cable health, and ensure seamless connectivity for communication and data transmission.',
      img: 'url(/industries/ocean-technology/submarine-cable-route-planning-and-maintenance-systems.jpg)',
      content:
        'Optimize route planning, monitor cable health, and ensure seamless connectivity for communication and data transmission with our Submarine Cable Route Planning and Maintenance Systems.',
      link: '/industries/ocean-technology/products/submarine-cable-route-planning-and-maintenance-systems',
    },
    {
      title: 'Oil Spill Detection and Response Software',
      subtitle:
        'Mitigate environmental risks with our Oil Spill Detection and Response Software. Detect oil spills in real-time, optimize response strategies, and contribute to rapid and effective environmental cleanup efforts.',
      img: 'url(/industries/ocean-technology/oil-spill-detection-and-response-software.jpg)',
      content:
        'Detect oil spills in real-time, optimize response strategies, and contribute to rapid and effective environmental cleanup efforts with our Oil Spill Detection and Response Software.',
      link: '/industries/ocean-technology/products/oil-spill-detection-and-response-software',
    },
    {
      title: 'Autonomous Surface Vessel (ASV) Control Systems',
      subtitle:
        'Navigate the surface of the ocean autonomously with our control systems for Autonomous Surface Vessels (ASVs). Enable precise control, data collection, and monitoring for various marine applications.',
      img: 'url(/industries/ocean-technology/autonomous-surface-vessel-control-systems.jpg)',
      content:
        'Enable precise control, data collection, and monitoring for various marine applications with our Autonomous Surface Vessel (ASV) Control Systems.',
      link: '/industries/ocean-technology/products/autonomous-surface-vessel-control-systems',
    },
    {
      title: 'Ocean Satellite Image Processing and Analysis Tools',
      subtitle:
        'Unlock the potential of ocean satellite imagery with our processing and analysis tools. Extract valuable information from satellite images to monitor ocean conditions and phenomena.',
      img: 'url(/industries/ocean-technology/ocean-satellite-image-processing-and-analysis-tools.jpg)',
      content:
        'Extract valuable information from satellite images to monitor ocean conditions and phenomena with our Ocean Satellite Image Processing and Analysis Tools.',
      link: '/industries/ocean-technology/products/ocean-satellite-image-processing-and-analysis-tools',
    },
    {
      title: 'Integrated Ocean Observing System (IOOS) Platforms',
      subtitle:
        'Contribute to a comprehensive ocean observing system with our platforms. Integrate diverse data sources for a holistic understanding of ocean dynamics and contribute to global oceanography efforts.',
      img: 'url(/industries/ocean-technology/integrated-ocean-observing-system-platforms.jpg)',
      content:
        'Integrate diverse data sources for a holistic understanding of ocean dynamics and contribute to global oceanography efforts with our Integrated Ocean Observing System (IOOS) Platforms.',
      link: '/industries/ocean-technology/products/integrated-ocean-observing-system-platforms',
    },
    {
      title: 'Coral Reef Monitoring and Conservation Software',
      subtitle:
        'Safeguard coral reefs with our monitoring and conservation software. Monitor coral health, assess threats, and contribute to conservation efforts to preserve these vital marine ecosystems.',
      img: 'url(/industries/ocean-technology/coral-reef-monitoring-and-conservation-software.jpg)',
      content:
        'Monitor coral health, assess threats, and contribute to conservation efforts to preserve these vital marine ecosystems with our Coral Reef Monitoring and Conservation Software.',
      link: '/industries/ocean-technology/products/coral-reef-monitoring-and-conservation-software',
    },
    {
      title: 'Marine Protected Area (MPA) Management Systems',
      subtitle:
        'Manage and protect marine ecosystems with our systems for Marine Protected Areas. Ensure effective conservation, monitor biodiversity, and enforce sustainable practices within protected areas.',
      img: 'url(/industries/ocean-technology/marine-protected-area-management-systems.jpg)',
      content:
        'Ensure effective conservation, monitor biodiversity, and enforce sustainable practices within protected areas with our Marine Protected Area (MPA) Management Systems.',
      link: '/industries/ocean-technology/products/marine-protected-area-management-systems',
    },
    {
      title: 'Deep-Sea Mining Exploration and Planning Software',
      subtitle:
        'Dive into the possibilities of deep-sea mining with our exploration and planning software. Optimize operations, assess resource potential, and contribute to responsible deep-sea mining practices.',
      img: 'url(/industries/ocean-technology/deep-sea-mining-exploration-and-planning-software.avif)',
      content:
        'Optimize operations, assess resource potential, and contribute to responsible deep-sea mining practices with our Deep-Sea Mining Exploration and Planning Software.',
      link: '/industries/ocean-technology/products/deep-sea-mining-exploration-and-planning-software',
    },
    {
      title: 'Ocean Data Archiving and Sharing Platforms',
      subtitle:
        'Collaborate and share ocean data seamlessly with our archiving and sharing platforms. Contribute to global oceanographic research by making data accessible to the scientific community.',
      img: 'url(/industries/ocean-technology/ocean-data-archiving-and-sharing-platforms.jpg)',
      content:
        'Contribute to global oceanographic research by making data accessible to the scientific community with our Ocean Data Archiving and Sharing Platforms.',
      link: '/industries/ocean-technology/products/ocean-data-archiving-and-sharing-platforms',
    },
    {
      title: 'Coastal Zone Management and Planning Software',
      subtitle:
        'Manage coastal zones effectively with our planning software. Facilitate sustainable development, address environmental challenges, and optimize land-use planning for coastal regions.',
      img: 'url(/industries/ocean-technology/coastal-zone-management-and-planning-software.jpg)',
      content:
        'Facilitate sustainable development, address environmental challenges, and optimize land-use planning for coastal regions with our Coastal Zone Management and Planning Software.',
      link: '/industries/ocean-technology/products/coastal-zone-management-and-planning-software',
    },
  ]

